module.exports = __webpack_public_path__ + "/login_ui/img/zm-d6412cf3d9b7459cd63f15ff34b6d37d.svg";